var map = {
	"./00-_DSC7578.jpg": 74,
	"./01-_DSC8994.jpg": 75,
	"./02-_DSC8989.jpg": 76,
	"./02_DSC5646.jpg": 77,
	"./03_DSC7759.jpg": 78,
	"./07-_DSC7025.jpg": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;